import { createFileRoute } from '@tanstack/react-router';
import { AdminPickupCostPage } from '@/features/admin/admin-pickup-cost-page';

export const Route = createFileRoute('/admin/pickup-cost/')({
  component: AdminPickupCostIndexRoute,
});

function AdminPickupCostIndexRoute() {
  return <AdminPickupCostPage />;
}
